<template>
    <div class="quotation">
        <span class="login" v-if="userInfo && userInfo.nickName">{{ userInfo.nickName }}</span>
        <span v-else @click="login" class="btn login">登录</span>
        <h1>价格计算</h1>
        <div class="form">
            <div><span class="btn btn-big" @click="newQuotation">新 增</span></div>
            <br />
            <table>
                <tr v-for="item in receiverList">
                    <td>{{ item.receiver }}</td>
                    <td style="width: 6rem;text-align: center;">
                        <span class="btn" @click="edit(item)" v-if="userInfo && userInfo.nickName">编辑</span>
                        <span class="btn" @click="qr(item)">二维码</span>
                        <span class="btn" @click="scan(item)">预览</span>
                        <span class="btn" @click="copy(item)" v-if="userInfo && userInfo.nickName">复制</span>
                        <span class="btn btn-remove" @click="remove(item)" v-if="userInfo && userInfo.nickName">删除</span>
                    </td>
                </tr>
            </table>
        </div>
        <div class="quotaion-form" v-show="receiverIsShow">
            <h2 class="title">{{ title }}</h2>
            <div class="form">
                <div class="form-item">
                    <label>合伙人</label>
                    ：<input v-model="form.receiver" type="text" />
                </div>
                <div class="form-item">
                    <label>备注</label>
                    ：<input v-model="form.remark" type="text" />
                </div>
                <br />
            </div>
            <br />
            <div class="btns">
                <span class="btn btn-big cancel" @click="receiverIsShow = false">取 消</span>
                <span class="btn btn-big" @click="save">保 存</span>
            </div>
        </div>

        <div class="del-wapper" v-show="delQuotationIsShow">
            <p style="text-align: center; line-height: 2rem;">您确定要删去吗？</p>
            <div class="btns">
                <span class="btn btn-big cancel" @click="delQuotationIsShow = false">取 消</span>
                <span class="btn btn-big" @click="del">确 定</span>
            </div>
        </div>
        <div class="del-wapper" v-show="loginIsShow">
            <h2 style="line-height: 2rem; text-align: center;">登录</h2>
            <div class="form">
                <div class="form-item">
                    <label>用户名</label>
                    ：<input v-model="loginForm.username" type="text" />
                </div>
                <div class="form-item">
                    <label>密 码</label>
                    ：<input v-model="loginForm.password" type="password" />
                </div>
                <br />
            </div>
            <br />
            <div class="btns">
                <span class="btn btn-big cancel" @click="loginIsShow = false">取 消</span>
                <span class="btn btn-big" @click="loginSubmit">登 录</span>
            </div>
        </div>
        <div class="del-wapper" v-show="qrQuotationIsShow">
            <div style="margin: 20px; text-align: center;">
                <img ref="qrImg" />
            </div>
            <p style="color:red;font-size: 0.3rem;text-align: center;">长按保存二维码图片</p>
            <br />
            <div class="btns">
                <span class="btn btn-big cancel" @click="qrQuotationIsShow = false">取 消</span>
                <!-- <span class="btn btn-big" @click="del">确 定</span> -->
            </div>
        </div>
    </div>
</template>
<script>
import { setToken } from '@/utils/auth'
import QRCode from 'qrcode'
import { listDocQuotationReceiver, delDocQuotationReceiver, addDocQuotationReceiver, updateDocQuotationReceiver, login, getInfo } from "@/api/docQuotationReceiver";
export default {
    data() {
        return {
            config: {},
            receiverList: [],
            receiverIsShow: false,
            delQuotationIsShow: false,
            qrQuotationIsShow: false,
            loginIsShow: false,
            loginForm: {},
            form: {
                single: "",
                weight: "",
                year: 1
            },
            delId: "",
            proportion: [],
            quotationShow: false,
            resultShow: false,
            resultValue: 0,
            list: [],
            title: '新增报价系数',
            userInfo: {}
        }
    },
    created() {
        this.getList()
        getInfo().then(res => {
            this.userInfo = res.user
        })
    },
    methods: {
        getList() {
            listDocQuotationReceiver({ pageNum: 1, pageSize: 100 }).then(res => {
                this.receiverList = res.rows
            })
        },
        goTo(item) {
            this.$router.push({ path: '/quotation-item', query: { sort: item.sort, title: item.name } })
        },
        scan(item) {
            this.$router.push({ path: '/quotation2', query: { _: item.id } })
        },
        expandJsonFormart(item) {
            let _json = JSON.parse(item.expandJson)
            let _vals = _json.scales.map(item => Object.values(item))
            return _vals.join('%、') + '%'
        },
        newQuotation() {
            this.form = {}
            // this.proportion = [{ '基价1': '10' }, { '阶段1': '20' }, { '阶段2': '30' }, { '阶段3': '40' }, { '阶段4': '50' }]
            this.receiverIsShow = true
        },
        edit(item) {
            this.form = item
            // this.proportion = JSON.parse(this.form.expandJson).scales
            // console.log(this.proportion)
            this.receiverIsShow = true
            this.title = '修改报价系数'
        },
        qr(item) {
            let url = 'https://y3wm.cn/quotation2?_=' + item.id
            console.log(url)
            QRCode.toDataURL(url).then(url => {
                this.$refs.qrImg.src = url
            }).catch(err => {
                console.error(err)
            })
            this.qrQuotationIsShow = true
        },
        copy(item) {
            this.form = item
            // this.proportion = JSON.parse(this.form.expandJson).scales
            // console.log(this.proportion)
            this.form.id = null
            this.receiverIsShow = true
            this.title = '复制报价系数'
        },
        cancel() {
            this.receiverIsShow = false
        },
        save() {
            console.log(this.proportion)
            this.submit()
        },
        remove(item) {
            this.delId = item.id
            this.delQuotationIsShow = true
        },
        del() {
            delDocQuotationReceiver(this.delId).then(res => {
                console.log(res)
                this.delQuotationIsShow = false
                this.getList()
            })
        },
        login() {
            this.loginIsShow = true
        },
        loginSubmit() {
            login(this.loginForm).then(res => {
                // document.cookie = res.token
                setToken(res.token)
                getInfo().then(res => {
                    this.userInfo = res.user
                    this.loginIsShow = false
                })
                // console.log(document.cookie)
            })
        },
        submit() {
            if (this.form.id) {
                // let _oldData = JSON.parse(this.form.expandJson)
                // _oldData.scales = this.proportion
                // this.form.expandJson = JSON.stringify(_oldData)
                updateDocQuotationReceiver(this.form).then(res => {
                    if (res.code == 200) {
                        this.receiverIsShow = false
                        this.getList()
                    }
                })
            } else {
                // this.form.expandJson = JSON.stringify({ scales: this.proportion, shares: [] })
                this.form.id = new Date().getTime() + ''
                addDocQuotationReceiver(this.form).then(res => {
                    if (res.code == 200) {
                        this.receiverIsShow = false
                        this.getList()
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.quotation {
    padding: 0.32rem;
    font-size: .4rem;

    .title,
    h1,
    .button {
        text-align: center;
    }

    .btn {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 0;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 0.1rem 0.2rem;
        font-size: 0.26rem;
        border-radius: 4px;
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
    }

    .btn-remove {
        background-color: #F56C6C;
        border-color: #F56C6C;
    }

    .btn-big {
        padding: 0.2rem 0.4rem;
        font-size: 0.3rem;
    }

    .login {
        position: absolute;
        right: 10px;
        top: 20px;
    }

    table {
        width: 100%;
        border: 1px solid #3a3a3b;
        border-radius: 20px;
        border-collapse: collapse;
        margin-bottom: 0.5rem;

        td {
            border: 1px solid #3a3a3b;
            font-size: 0.3rem;
            padding: 0.15rem;


        }

        .btns {
            text-align: center;


        }

        .label {
            text-align: right;
            width: 2rem;
        }
    }

    h1 {
        font-size: 0.64rem;
        line-height: 2rem;
    }

    dd {
        color: #409eff;
    }

    dt {
        text-align: center;
        line-height: 0.8rem;
    }

    .del-wapper {
        position: fixed;
        left: 50%;
        top: 50%;
        width: 80%;
        box-shadow: 0px 0px 5px 3px #ccc;

        background-color: #fff;
        border-radius: 10px;
        transform: translate(-50%, -50%);

        .btns {
            text-align: center;
            margin-bottom: 20px;
        }
    }

    .quotaion-form {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        overflow-y: auto;

        h2 {
            line-height: 2rem;
        }

        .btns {
            text-align: center;
        }
    }

    .form {
        dd {
            line-height: 1rem;
        }

        font-size: 0.35rem;

        .form-item {
            padding-bottom: 10px;

            label {
                display: inline-block;
                width: 2.2rem;
                text-align: right;
                vertical-align: middle;
            }
        }

        input[type='text'],
        input[type='password'],
        textarea {
            padding: 4px 8px;
            text-align: center;
            width: calc(100% - 3.8rem);
        }
    }

    .button-wapper {
        text-align: center;
    }

    .button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 0;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 8px 15px;
        width: 80px;
        font-size: 12px;
        border-radius: 4px;
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
    }

    .cancel {
        background-color: #c0c2c4;
        border-color: #c0c2c4;
    }

    .tip {
        font-size: 14px;
        line-height: 0.6rem;
    }

    .result {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: #dcdfe6;
        padding: 16px;
        text-align: center;
        box-sizing: border-box;

        .button-result {
            width: 100%;
            height: 80px;
            position: absolute;
            bottom: 0;
            margin-left: -16px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/quotation2/params-manager.vue